import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Stack,
  Skeleton,
} from "@mui/material";

const TrackerDialog = ({ open, onClose, ticketDetails }) => {
  if (!ticketDetails) return null;

  const status = ticketDetails.creationStatus ? "Active" : "Inactive";
  const statusColor = ticketDetails.creationStatus ? "#2e7d32" : "#d32f2f";

  const isLoading = !ticketDetails;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disableScrollLock
    >
      <DialogTitle>Ticket Details</DialogTitle>
      <DialogContent
        dividers
        sx={{
          maxHeight: "calc(100vh - 200px)",
          overflowY: "auto",
          wordBreak: "break-word",
        }}
      >
        <Stack spacing={2}>
          {isLoading ? (
            // Show skeletons while loading
            <>
              {[...Array(12)].map((_, index) => (
                <Stack
                  key={index}
                  direction="row"
                  spacing={1}
                  alignItems="center"
                >
                  <Skeleton width={120} height={24} />
                  <Skeleton width="60%" height={24} />
                </Stack>
              ))}
            </>
          ) : (
            <>
              <Typography>
                <strong>Request Type:</strong> {ticketDetails.requestType}
              </Typography>
              <Typography>
                <strong>Requested Role:</strong> {ticketDetails.requestedRole}
              </Typography>
              <Typography>
                <strong>Process:</strong> {ticketDetails.process}
              </Typography>
              <Typography>
                <strong>First Name:</strong> {ticketDetails.firstName || "N/A"}
              </Typography>
              <Typography>
                <strong>Last Name:</strong> {ticketDetails.lastName || "N/A"}
              </Typography>
              <Typography>
                <strong>Requester Email:</strong>{" "}
                {ticketDetails.requesterEmail || "N/A"}
              </Typography>
              <Typography>
                <strong>Raised By:</strong> {ticketDetails.raisedBy}
              </Typography>
              <Typography>
                <strong>Environment:</strong> {ticketDetails.environment}
              </Typography>
              <Typography>
                <strong>Description:</strong>{" "}
                {ticketDetails.description || "None"}
              </Typography>
              <Typography>
                <strong>Ticket Number:</strong>{" "}
                {ticketDetails.ticketNo || "Pending"}
              </Typography>
              <Typography>
                <strong>Status:</strong>
                <span
                  style={{
                    color: statusColor,
                    marginLeft: "8px",
                    fontWeight: 500,
                  }}
                >
                  {status}
                </span>
              </Typography>
              <Typography>
                <strong>Request Status:</strong> {ticketDetails.status}
              </Typography>
            </>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: "black",
            "&:hover": { backgroundColor: "#333" },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TrackerDialog;
